import styled from "styled-components";
import Img from "../../../../assets/images/Worker_Supplier_new.jpg";
import Img2 from "web/assets/images/supplier-community-palletyard.png"
// import Img2 from "../../../../assets/images/community_new.jpeg";
import Group7 from "../../../../assets/images/Frame-1.jpg";
export const Container = styled.div``;
export const Wrapper = styled.div`
    h1,
    h2,
    h3,
    h4 {
      font-family: ITC Franklin Gothic Std;
    }
    p{
    font-size: 1.5rem;
   }
   h2 {
    font-size: 2.759rem;
    @media (max-width: 767px) {
        font-size: 1.5rem !important;
    }
  }
  h2{
    @media (max-width: 767px) {
        font-size: 1.5rem !important;
    }
  }
  p{
    @media (max-width: 767px) {
        font-size: 14px !important;
    }
  }
  max-width: 1440px;

  // padding: 0 clamp(20px, 3.194vw, 46px);
  button {
    background-color: #233354;
    font-weight: 400;
    color: rgb(255, 255, 255);
    border: none;
    margin-top: min(1.75vw, 25px);
    font-size: 14px;
    padding: 8px 20px;
    width: 250px;
  }

  margin: 0 auto;
  @media (max-width: 768px) {
    // padding: min(5.11vw, 73px);
  }

  .banners {
    background-image: url(${Img});
    width: 100%;
    position: relative;
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
    padding: 16px;
    height: 550px;
    display: flex;
    align-items: center;

    @media (max-width: 1023px) {
      height: 285px;
    }

    .quotes {
      position: fixed;
      z-index: 99;
      right: 0;
      top: 318px;
      right: 0;
      div{
        margin-left: 0 !important;
      }
      @media (min-width: 1441px) {
        margin-right: calc(50vw - 726px);
      }
      @media (max-width: 1023px) {
        top: 252px;
      }
      @media (max-width: 767px) {
        top: 294px;
      }

      button {
        background-color: #ff0000c7;
        color: #fff;
        border: none;
        padding: 12px;
        font-size: 16px;
        width: 155px;
        margin-top: min(1.75vw, 25px);
      }
    }
    h2,
    h3,
    h4 {
      font-family: ITC Franklin Gothic Std;
    }
    .banner-texts {
      margin-left: 6.25vw;
      color: #ffffff;
      /* z-index: 101; */
      opacity: 2;
      background: #00000047;
      padding: 40px;
      @media (max-width: 1024px) {
        padding: 17px;
        height: 288px;
      }

      p {
        width: 637px;
        @media (max-width: 1024px){
          width: 490px;
          font-size: 1.4rem;
        }
        
      }

      h2 {
        font-weight: 500;
        @media (max-width: 1024px) {
          font-size: 2rem;
      }

        /* &.mb-4 {
          margin-bottom: 4px !important;
        } */
      }
    }

    @media (max-width: 1024px) {
      .quotes {
        /* bottom: 118px; */

        button {
          padding: 8px !important;
          font-size: 14px !important;
          width: 155px !important;
        }
      }
    }

    @media (max-width: 767px) {
      background-size: cover;
      height: 410px;
      /* padding: 17px; */
      /* padding-bottom: 41px; */
      padding:0;
      .banner-texts {
        /* margin-left: -5px;
        padding: 13px;
        max-width: 253px;
        height: 225px; */
        margin-left: -9px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 28px;
        height: 410px;
        p {
          font-size: 21px !important;
          width: 100%;
          margin-top: 5px;
        }

        h2 {
          font-size: 2rem !important;
          &.mb-4 {
          margin-bottom: 15px !important;
          margin-top: -2px;
        }
        }
      }

      .quotes {
        /* bottom: 118px; */
        button {
          padding: 4px !important;
          font-size: 11px !important;
          width: 132px !important;
        }
      }
    }
  }


  .efficiency01 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 4vw;

    .process {
      margin-top: 0.8vw;
      background-color: #e9ecec;

      .box-3-wrp {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 2rem;
        justify-content: center;
        align-items: center;

        @media (max-width: 1024px) {
          gap: 1rem;
          button {
            width: 184px;
          }

          @media (max-width: 767px) {
            grid-template-columns: 1fr;
            gap: 1rem;
            padding: 0px 2px;
          }
        }

        @media (max-width: 767px) {
          grid-template-columns: 1fr;
          gap: 1rem;
          padding: 0px 2px;
        }

        .box-info {
          background-color: #e3f1fb;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          li {
            list-style: disc;
            margin-left: 16px;
          }
        }
      }

      .process_title {
        padding: 1.2rem;

        h2 {
          text-align: center;
          color: #233354;
          font-family: ITC Franklin Gothic Std;
        }
      }

      .img-bg {
        min-height: 162px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .text-bg {
        background-color: #233354;
        color: #ffffff;
        height: 193px;
        padding: 18px;
        display: grid;
        justify-content: center;
        align-items: center;
        place-items: center;
        text-align: center;
        width: 100%;

        ul {
          text-align: left;
        }

        h4 {
          margin-bottom: 25px;
          font-size:34px;
        }
      }

      @media (max-width: 767px) {
        .process_title {
          padding: 22px 12px;

          h2 {
            font-size: 33px;
          }
        }

        .img-bg {
          padding: 16px;
        }
      }
    }

    .boxes {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 39px;
      background-color: #ffffff;
      padding: 26px;

      button {
        background: #1f396c;
        color: #fff;
        border: none;
        font-size: 14px;
        padding: 8px 20px;
        width: 250px;
        text-transform: uppercase;
        font-weight: 500;
      }

      @media (max-width: 767px) {
        flex-direction: column;
        gap: 16px;
      }
    }
  }

  
  .what_you_get {
    font-family: sans-serif;
    display: flex;
    flex-direction: column;
    margin: 4vw 0;
    transform: scale(1);
    -ms-transform: scale (1);
    -webkit-transform:scale(1);
    -moz-transform: scale(1);
    -o-transform: scale(1);

    .what_you_get-container {
      background: #efefef;
      @media (max-width: 767px) {
        h2{
          font-size: 1.5rem !important;
        }
      }
    }

    .what_you_get-container > h2 {
      font-family: ITC Franklin Gothic Std;
      color: #233354;
      text-align: center;
      padding: 1.2rem;
    }

    .what_you_get-container > p {
      text-align: center;
    }

    .what_you_get-container .cards-container {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 1rem;
    }
    .what_you_get-container .cards-container .card {
      display: flex;
      flex-direction: column;
    }

    .what_you_get-container .cards-container .card .img-box {
      background: #e4f1f9;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 1rem 1rem;
      position: relative;
      height: 218px;
      border: 2px solid #233354;
      @media (max-width: 767px) {
        height: 163px;
      }
      #icon2-id{
        padding-top: 51px;
      }
    }

    .what_you_get-container .cards-container .card .text-box .hover-box {
      background: #233354;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 1.3rem;
      text-align: center;
      position: absolute;
      width: 100%;
      transform: scale(0);
      top: 0;
      left: 0;
      border: 1px solid #a6a6a6;
      z-index: 10;
      box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
      transition: all 0.4s;
      h4 {
        color: #ffffff;
      }
    }

    .what_you_get-container .cards-container .card .text-box .hover-box.active {
      display: flex;
      transform: scale(1.04);
      transition: all 0.4s;
      @media (max-width: 767px) {
        transform: scale(1);
        width: 100%;
      }
    }

    .what_you_get-container .cards-container .card .text-box .hover-box ul {
      margin: 0;
      margin-top: 1.3rem;
      padding: 0;
      color: #fff;
      list-style: none;
      text-align: start;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      font-size: 0.85rem;
    }

    .what_you_get-container .cards-container .card .text-box .hover-box > img {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 0.6rem;
      height: auto;
      cursor: pointer;
    }

    .what_you_get-container .cards-container .card .text-box .hover-box ul li {
      display: flex;
      align-items: flex-start;
      gap: 0.5rem;
      font-size: 16px;
      @media (max-width: 1024px){
        font-size: 15px;
      }
    }

    .what_you_get-container .cards-container .card .text-box .hover-box ul li img {
      width: 10px;
      height: auto;
      padding-top: 0.3rem;
    }

    .what_you_get-container .cards-container .card .text-box img {
      max-width: 100%;
      height: 100px;
      object-fit: contain;
    }

    .what_you_get-container .cards-container .card .text-box {
      background: #233354;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 1.3rem 1rem 1rem 1rem;
      text-align: center;
      gap: 0.5rem;
      flex: 1 1 0%;
      /* line-height: 190%; */
      position: relative;
    }

    .what_you_get-container .cards-container .card .text-box > h4,
    .what_you_get-container .cards-container .card .img-box .hover-box > h4 {
      font-size: 30px;
      color: #fff;
      font-weight: 500;
      margin: 0;
      @media (max-width: 1024px){
        font-size: 32px;
      }
      @media (max-width: 767px){
        font-size: 1.5rem;
      }
    }

    .what_you_get-container .cards-container .card .text-box > p {
      font-size: 1.2rem;
      color: #23759f;
      text-decoration: underline;
      margin: 0;
      cursor: pointer;
    }
    @media (max-width: 767px) {
      .cards-container {
        display: grid !important;
        grid-template-columns: 1fr !important;
        padding: 0 16px;
        .hover-box {
          /* width: 124% !important; */
        }
      }
    }
    /* for tablet */
    @media (min-width: 500px) and (max-width: 1050px) {
    }

    /* For Mobile */
    @media (max-width: 500px) {
    }
  }


  .our_expertise {
    background-color: #e3f1fb;
    width: 100%;
    background-repeat: repeat;
    background-position: right;
    background-size: contain;
    margin: 4vw 0;
    background-image: url(${Img2});
    /* background-size: cover; */
    @media (max-width: 1023px) {
      background-size: cover;
        }
    &.suppliers {
      background-image: url(${Group7});
      background-size: cover;
      margin-top: -4px;
    }

    .expertise_overlay {
      background: linear-gradient(109deg, #ee0000bf 50%, transparent 50%);
      height: 700px;
      color: #ffffff;
      padding: 16px;
      padding-left: 6.25vw;
      padding-right: 6.25vw;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      &.join{
        background:linear-gradient(109deg, #b40001eb 50%, transparent 50%);
        @media(max-width: 767px){
          background: linear-gradient(180deg, #ee0000c4 100%, #e3f1fb 34%);
        }
      }
      p{
        margin-top: 42px;
      }
      &.newsroom{
        height: 650px;
        background:linear-gradient(109deg, #b40001eb  50%, transparent 50%);
      }
      h2{
        font-family: "ITC Franklin Gothic Std";
      }

      .digital_supplier_img {
        img {
          max-width: 495px;
          object-fit: cover;

          @media (max-width: 1023px) {
            max-width: 250px;
          }
        }
      }

      .max-w {
        max-width: 537px;
        /* font-size: 17px; */

        @media (max-width: 1023px) {
          max-width: 264px;
        }
        @media (max-width: 767px){
          p{
            margin-top: 18px;
          }
         
        }
      }

      .grid {
        display: grid;

        button {
          background-color: #ffffff;
          color: #ee0000;
          width: 270px;
          font-weight: 600;
        }
      }
    }

    @media (max-width: 1024px) {
      .our_expertise{
        background-size: cover;
      }
      .expertise_overlay {
        height: 663px;
        padding-left: 4.25vw;
        background: linear-gradient(109deg, #ee0000bf 55%, transparent 55%);
        h2 {
          font-size: 1.7rem;
        }
      }
      .newsroom {
        height: 500px !important;
      }
    }

    @media (max-width: 767px) {
      background-size: cover;
      margin: 5.5vw 3.5vw !important;
      width: auto;
      .expertise_overlay {
        background: linear-gradient(180deg, #ee0000c4 100%, #e3f1fb 34%);
        height: 357px;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        h2 {
          font-size: 20px;
        }

        p {
          font-size: 14px;
          margin-top: 18px;
        }

        .digital_supplier_img {
          img {
            max-width: 290px;
          }
        }

        .grid {
          display: grid;

          button {
            background-color: #ffffff;
            color: #ee0000;
            width: 270px;
          }
        }
      }

      &.suppliers {
        .expertise_overlay {
          background: linear-gradient(180deg, #ee0000c4 100%, #e3f1fb 34%);
          height: 300px !important;
        }
      }
    }
  }

  * {
    box-sizing: border-box;
  }

  .main {
    font-family: sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
     h2{
      color:#20396D;
      font-family: 'ITC Franklin Gothic Std';
      /* font-size: 2.4rem; */
      @media (max-width: 767px){
        font-size: 2rem !important;
      }
     }
    .main > h1 {
      margin-bottom: 0rem;
      color: #20396D;
    }

    .main > p {
      margin-bottom: 3rem;
      font-weight: 500;
      text-align: center;
    }

    .list-wrapper {
      /* display: flex;
      flex-direction: column; */
      display: grid;
      grid-template-rows: repeat(4, 1fr);
      gap: 1.8rem;
      /* width: 60%; */
      margin: 0 3.5vw;
    }
    
    .item-container {
      display: flex;
      position: relative;
    }

    .item-container .number-box {
      background: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      transform: translate(2rem, -4%);
    }

    .item-container .number-box .number {
      font-size: 9.3rem;
      line-height: 50%;
      font-weight: 800;
      position: relative;
      z-index: 11;
    }

    .item-container.first .number-box .number {
      color: #00a5d7;
    }

    .item-container.first .icon-box {
      background: #00a5d7;
    }
    /* .traingle{
      clip-path: polygon(100% 50%, 0 0, 0 100%);
       width: 55px;
    position: relative;
    left: 0px;
    } */
    .item-container.first .traingle {
      border-left: 55px solid #00a5d7;
    }

    .item-container.second .number-box .number {
      color: #1a75bb;
    }

    .item-container.second .icon-box {
      background: #1a75bb;
    }

    .item-container.second .traingle {
      border-left: 55px solid #1a75bb;
    }

    .item-container.third .number-box .number {
      color: #293b8e;
    }

    .item-container.third .icon-box {
      background: #293b8e;
    }

    .item-container.third .traingle {
      border-left: 55px solid #293b8e;
      /* border-bottom: 70px solid transparent;
      border-top: 70px solid transparent; */
    }

    .item-container.fourth .number-box .number {
      color: #1f396c;
    }

    .item-container.fourth .icon-box {
      background: #1f396c;
    }

    .item-container.fourth .traingle {
      border-left: 55px solid #1f396c;
    }

    .item-container .number-box .number-shadow {
      font-weight: 800;
      font-size: 9.3rem;
      line-height: 100%;
      -webkit-text-fill-color: #fff;
      -webkit-text-stroke: 25px;
      color: #fff;
      z-index: 10;
      position: absolute;
    }

    .item-container .icon-box {
      width: 33%;
      color: #fff;
      display: flex;
      gap: 1rem;
      align-items: center;
      padding-left: 3.5rem;
    }

    .item-container .icon-box p {
      display: flex;
      flex: 1 0 0;
      text-align: left;
      justify-content: flex-start;
      font-weight: 700;
      font-size: 1.8rem;
      z-index: 4;
      margin-bottom: 0;
    }

    .item-container .icon-box img {
      max-height: 75px;
      max-width: 55px;
      object-fit: contain;
    }
    .item-container .icon-box .store{
      max-width: 75px;
      margin-left: -10px;
    }
    .item-container .icon-box .digital{
      margin-left: -4px;
    }
    .item-container .icon-box .coffee{
      max-width: 70px;
      margin-left: -4px;
    }

    .item-container .traingle {
      clip-path: polygon(100% 50%, 0 0, 0 101%);
       width: 55px;
      position: relative;
      left: -1px;
      background: transparent;
    }
    .bg-wrap{
      background: #d9f2f9;
      display: flex;
    width: 100%;
    }

    .item-container .description-box {
      background: #d9f2f9;
      display: flex;
      align-items: center;
      flex: 1 0 0;
      padding: 3px 5rem;
      padding-left: 23px;
      font-size: 1.5rem;
      font-family: "latoregular", Arial, Helvetica, sans-serif;
    }
   .main_text{
     margin-top: 1px;
   }
    

    .btn-container01 {
      display: flex;
      justify-content: center;
      gap: 3rem;
      margin-top: 2rem;
    }

    .btn-container01 button {
      background: #1f396c;
      color: #fff;
      font-size: 0.8rem;
      padding: 0.7rem 1rem;
      border: none;
      text-transform: uppercase;
      font-weight: 500;
      margin-top: -18px;
    }

    .item-wrap {
      display: flex;
      width: 100%;
    }

    @media (min-width: 500px) and (max-width: 800px) {
      .list-wrapper {
        width: 90%;
      }
      .icon-box p{
      font-size: 18px !important;
    }
      .item-container .icon-box {
        /* width: 39%; */
      }
      .first .traingle{
        border-left: 67px solid #00a5d7 !important;
      }
      .second .traingle{
        border-left: 67px solid #1a75bb !important;
      }
      .third .traingle{
        border-left: 67px solid #293b8e !important;
      }
      .fourth .traingle{
        border-left: 67px solid #1f396c !important;
      }
      
    }
    @media only screen and (min-width: 360px) and (max-width: 767px) {
      .item-container .description-box{
        font-size: 12px !important;
      }
     }


    @media (max-width: 500px) {
      .list-wrapper {
        width: 100%;
        gap: 1.2rem;
      }

      .item-container {
        width: 96%;
        align-items: start;
        /* transform: translateX(-3%); */
      }

      .item-container .number-box .number,
      .item-container .number-box .number-shadow {
        /* font-size: 5.7rem; */
        font-size: 77px;
      }

      .item-container .number-box {
        transform: translate(1rem, 25%);
      }

      .item-container .icon-box img {
        max-height: 5rem;
        /* max-width: 2.6rem; */
        max-width: 35px;
        padding-top: 37px;
      }

      .item-container .icon-box {
        padding: 0rem 0.5rem 0rem 2rem;
        /* width: auto; */
        flex: 1 0 0;
        /* width: 188px; */
        height: 169px;
        min-width: 144px;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .store{
        max-width: 49px !important;
      }
      .coffee{
        max-width: 43px !important;
      }
      }

      .item-container .icon-box p {
        /* font-size: 0.85rem; */
        font-size: 17px !important;
        text-align: center;
      }

      .item-container .traingle {
        font-weight: 800;
        width: 33px;
        position: relative;
      } 

      .item-container.first .traingle {
        border-left: 33px solid #00a5d7;
      }

      .item-container.second .traingle {
        border-left: 33px solid #1a75bb;
      }

      .item-container.third .traingle {
        border-left: 33px solid #293b8e;
      }

      .item-container.fourth .traingle {
        border-left: 33px solid #1f396c;
      }

      .item-container .description-box {
        /* display: none; */
        padding: 19px 5px;
        font-size: 14px;
        height: 169px;
        font-weight: 530;
        padding-left: 11px;
      }

      .item-container .number-box .number-shadow {
        -webkit-text-stroke: 16px;
      }

      .btn-container01 {
        gap: 34px;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }

      .main_text {
        text-align: center;
      }
      
    }
  }

  .CONTAINERS {
    .faqcontainer{
      width: 100%;
      margin: 40px auto;
      margin-top: 4vw;
      padding: 20px;
      text-align: center;
      background: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-family: "ITC Franklin Gothic Std";
    }
    .container {
      width: 100%;
      margin: 40px auto;
      padding: 20px;
      text-align: center;
      background: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-family: "ITC Franklin Gothic Std";
    }

    .header {
      margin-bottom: 10px;
      color: #1f396c;
      @media (max-width: 767px){
       font-size: 2rem !important;
      }

    }

    .subheader {
      font-size: 25px;
      margin-bottom: 20px;
      margin-top: 2px;
    }

    .benefits-list {
      list-style: none;
      padding: 0;
      width: 100%;
      text-align: left;
    }

    .accordion-item {
      border-bottom: 3px solid #1f396c;
    }

    .accordion-label {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 23px;
      color: #20396d;
      cursor: pointer;
      padding: 4px 0;
      font-family: "ITC Franklin Gothic Std";
    }
    .reach-new-markets {
      border-top: 3px solid #1f396c;
      margin-top: 10px;
    }

    .toggle-icon {
      font-size: 37px;
    }

    .accordion-content {
      padding: 10px;
      font-size: 17px;
      transition: max-height 0.3s ease;
    }

    .buttons-01 {
      display: flex;
      flex-direction: row;
      gap: 60px;
      margin-top: 25px;
    }

    .button {
      /* background-color: #003366; */
      background-color: #233354;
      color: rgb(255, 255, 255);
      /* color: #fff; */
      border: none;
      font-size: 14px;
      /* padding: 0.7rem 1rem; */
      padding: 8px 20px;
      width: 100%;
      min-width: 250px;
      cursor: pointer;
      margin: 5px 0;
      font-family: "latoregular", Arial, Helvetica, sans-serif;
    }

    .button:hover {
      background-color: #002244;
    }

    @media (max-width: 1023px) {
      .container {
        width: 100% !important;
      }

      .buttons-01 {
        gap: 20px;
      }
    }

    @media (max-width: 767px) {
      .container {
        width: 100%;
      }
      .subheader{
        font-size:22px;
      }
      .buttons-01 {
        gap: 20px;
        flex-direction: column;
      }
    }
  }

  .search_marketplace {
    padding: 1vw 16px;
    margin-top: 3vw;
    /* display: grid; */
    justify-content: center;
    text-align: center;
    align-items: center;
    text-align: center;
    @media (max-width: 767px){
      /* margin-bottom: 16px; */
      padding: 7vw 16px;
    }
    @media (max-width: 1023px) {
      .search_marketplace {
        display: inline-block;
      }
    }
    h2 {
        font-family: ITC Franklin Gothic Std;
        color: #233354;
        @media (max-width: 767px){
          font-size: 1.7rem !important;
          display: contents;
        }
      }
    .register {
      gap: 3vw;
      display: flex;
      align-items: center;
      justify-content: center;

      button {
        background-color: #233354;
        color: rgb(255, 255, 255);
      }
      
      @media (max-width: 1023px) {
        button {
          width: 215px;
          align-items: center;
          justify-content: center;
        }
      }
      @media (max-width: 767px){
        margin-top: 6px;
      }
    }
  }
`;
